import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';

/**
 * Custom Validator to check if a string is a valid JWT
 * @returns A ValidatorFn
 */
export function jwtValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // If the value is empty, don't validate it here; use the required validator separately
    if (!value) {
      return null;
    }

    try {
      // Attempt to decode the JWT
      jwtDecode(value);

      return null; // If decoding succeeds, it's a valid JWT
    } catch {
      return { invalidJwt: true }; // Return an error object if decoding fails
    }
  };
}
